import { Card, Input, Row, Typography, Button, Spin, message, Col, Modal } from "antd";
import { useEffect, useState, useContext } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../utils/HTTPClient";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment/moment";
import { TeamOutlined, CopyOutlined, RightOutlined, EditOutlined, ChromeFilled, FacebookFilled, InstagramFilled, LinkedinFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { render } from "@testing-library/react";
import Joyride from "react-joyride";
import { WelcomeModal } from "./WelcomeModal";
import { EditModal } from "./EditModal";
import { BuyModal } from "./BuyModal";
import SocialsCard from "./SocialsCard";
import InfoCard from "./InfoCard";
import StatCard from "./StatCard";

const AB_Home = () => {
    const navigate = useNavigate();
    const [homeData, setHomeData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation();

    const steps = [
        {
            target: "#sider_logo",
            content: t("ab_home.welcome_tour.step1"),
            disableBeacon: true,
        },
        {
            target: "#ab_home_content",
            content: t("ab_home.welcome_tour.step2"),
            disableBeacon: true,
        },
        {
            target: "#ab_home_edit_info",
            content: t("ab_home.welcome_tour.step3"),
            disableBeacon: true,
        },
        {
            target: "#menu3",
            content: t("ab_home.welcome_tour.step4"),
            disableBeacon: true,
        },
        {
            target: "#menu4",
            content: t("ab_home.welcome_tour.step5"),
            disableBeacon: true,
        },
        {
            target: "#menu5",
            content: t("ab_home.welcome_tour.step6"),
            disableBeacon: true,
        }
    ];

    const fetch = async () => {
        setLoading(true);
        try {
            const res = await HTTPClient.get("/ab_home/");
            setHomeData(res.data);
        } catch (err) {
            setHomeData({});
        }
        setLoading(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    const handleCallback = (data) => {
        const {
            type,
        } = data;
        if (type === "tour:end") {
            HTTPClient.post("/ab_home/tour_completed").then(() => {
                setHomeData({ ...homeData, tour_completed: true });
            });
        }
    };

    const saveProjectInfo = async (project_info) => {
        setLoading(true);
        HTTPClient.post("/ab_home/project_info", project_info).then((res) => {
            message.success(t("ab_home.edit_modal.success"));
            setHomeData(res.data);
            setIsModalOpen(false);
            setLoading(false);
        }).catch((err) => {
            message.error(t("ab_home.edit_modal.error"));
            setLoading(false);
        });
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (<div id="ab_home_content">
        <Joyride
            steps={steps}
            callback={handleCallback}
            run={homeData?.tour_completed === false || JSON.stringify(homeData) === "{}"}
            showProgress
            hideCloseButton
            continuous
            disableScrolling
            locale={{
                "last": "Finish"
            }}
            styles={{
                options: {
                    zIndex: 10000,
                },
            }}
        />
        <Row style={{ backgroundColor: "white", width: "100%", height: "134px", padding: "27px 34px" }} id="ab_home_title">
            <Row style={{ width: "100%", justifyContent: "space-between" }}>
                <Col>
                    <Typography.Text style={{ fontSize: "27px", fontWeight: "bold" }}>
                        {t("ab_home.title")}
                    </Typography.Text>
                </Col>
                <Col>
                    <Button id={"ab_home_edit_info"} onClick={() => setIsModalOpen(true)}><EditOutlined style={{ fontSize: "150%" }} />{t("ab_home.edit_modal.title")}</Button>
                </Col>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text style={{ fontSize: "20px" }}>{t("ab_home.subtitle")}</Typography.Text>
            </Row>
        </Row>
        <Row style={{ padding: isLargeScreen ? "27px 34px" : "10px 10px" }}>

            {loading || !homeData ? (
                <div
                    style={{
                        width: "100%",
                        minHeight: "20vh",
                        overflow: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <Spin />
                </div>
            ) : (
                <>
                    <Row style={{ width: "100%" }}>
                        <Col span={isLargeScreen ? 16 : 24} style={{ marginTop: isLargeScreen ? "0px" : "70px", marginBottom: isLargeScreen ? "0px" : "70px", boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "300px", display: "flex", alignItems: "center", paddingTop: "25px", paddingBottom: "25px", paddingLeft: "27px", borderRadius: "27px" }}>
                            <Row style={{ width: "100%", height: "200px" }}>
                                {isLargeScreen && <Col span={6}>
                                    <img src={homeData?.project_info?.logo_url || "/logo_home_example.jpg"} style={{ maxWidth: "100%", height: "200px", borderRadius: "14px" }} />
                                </Col>}
                                <Col span={isLargeScreen ? 18 : 24} style={{ padding: "20px 20px" }}>
                                    <Row>
                                        <Row style={{ width: "100%", display: "flex" }}>
                                            <Typography.Text style={{ fontSize: "24px", fontWeight: "bold" }}>{homeData?.project_info?.name || t("ab_home.project_info_placeholders.name")}</Typography.Text>
                                        </Row>
                                        <Row style={{ width: "100%", display: "flex" }}>
                                            <Typography.Text style={{ fontSize: "14px", fontWeight: "bold" }}>{homeData?.project_info?.sector || t("ab_home.project_info_placeholders.sector")}</Typography.Text>
                                        </Row>
                                        <Row style={{ width: "100%", display: "flex" }}>
                                            <Typography.Text style={{ fontSize: "14px" }}>{homeData?.project_info?.business_description?.slice(0, 400) + "..." || t("ab_home.project_info_placeholders.description")}</Typography.Text>
                                        </Row>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        {isLargeScreen && <Col span={1}></Col>}
                        <Col span={isLargeScreen ? 7 : 24} >
                            <Row style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "140px", padding: "18px 22px", borderRadius: "14px" }}>
                                <Col style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                                    <Row><Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("ab_home.socials_title")}</Typography.Text></Row>
                                    <Row style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                        <Col style={{ marginRight: "10px" }}><a href={homeData?.project_info?.socials?.website} target="_blank" ><ChromeFilled style={{ fontSize: "350%", color: "black" }} /></a></Col>
                                        <Col style={{ marginRight: "10px" }}><a href={homeData?.project_info?.socials?.facebook} target="_blank" ><FacebookFilled style={{ fontSize: "350%", color: "black" }} /></a></Col>
                                        <Col style={{ marginRight: "10px" }}><a href={homeData?.project_info?.socials?.instagram} target="_blank" ><InstagramFilled style={{ fontSize: "350%", color: "black" }} /></a></Col>
                                        <Col><a href={homeData?.project_info?.socials?.linkedin} target="_blank" ><LinkedinFilled style={{ fontSize: "350%", color: "black" }} /></a></Col>
                                    </Row>
                                </Col>
                            </Row>
                            <a><Row onClick={() => navigate("/website")} style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "140px", padding: "18px 22px", borderRadius: "14px", marginTop: "20px" }}>
                                <Col span={10} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                    <Row><Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("ab_website.leads.title")}</Typography.Text></Row>
                                </Col>
                                <Col span={8} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Row><Typography.Text style={{ fontSize: "24px", fontWeight: "bold" }}>{homeData?.website_leads?.length || "0"}</Typography.Text></Row>
                                </Col>
                                <Col span={6} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Row><RightOutlined style={{ fontSize: "200%", color: "black" }} /></Row>
                                    <Row><Typography.Text>Website</Typography.Text></Row>
                                </Col>
                            </Row></a>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "35px", width: "100%", height: "380px" }}>
                        <Col span={isLargeScreen ? 7 : 24}>
                            <a><Row onClick={() => navigate("/flow")} style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "130px", padding: "18px 22px", borderRadius: "14px" }}>
                                <Col span={10} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                    <Row><Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("ab_flow.usage.title")}</Typography.Text></Row>
                                </Col>
                                <Col span={8} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Row><Typography.Text style={{ fontSize: "24px", fontWeight: "bold" }}>{homeData?.flow?.usage}/{homeData?.flow?.limit}</Typography.Text></Row>
                                </Col>
                                <Col span={6} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Row><RightOutlined style={{ fontSize: "200%", color: "black" }} /></Row>
                                    <Row><Typography.Text>Flow</Typography.Text></Row>
                                </Col>
                            </Row></a>
                        </Col>
                        {isLargeScreen && <Col span={1} />}
                        <Col span={isLargeScreen ? 7 : 24} >
                            <a><Row onClick={() => navigate("/ai-studio")} style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "130px", padding: "18px 22px", borderRadius: "14px" }}>
                                <Col span={10} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                    <Row>
                                        <Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("ab_ai_studio.usage.title")}</Typography.Text>
                                    </Row>
                                </Col>
                                <Col span={8} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Row><Typography.Text style={{ fontSize: "24px", fontWeight: "bold" }}>{homeData?.ai?.usage}/{homeData?.ai?.limit}</Typography.Text></Row>
                                </Col>
                                <Col span={6} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Row><RightOutlined style={{ fontSize: "200%", color: "black" }} /></Row>
                                    <Row><Typography.Text>AI Studio</Typography.Text></Row>
                                </Col>
                            </Row></a>
                        </Col>
                    </Row>
                </>
            )}

        </Row>
        <EditModal open={isModalOpen} onClose={() => setIsModalOpen(false)} projectInfo={homeData?.project_info} saveProjectInfo={saveProjectInfo} />
        <WelcomeModal open={homeData !== null && !homeData?.project_info?.business_description && homeData?.tour_completed} fetch={fetch} />
        <BuyModal open={homeData?.project_info?.business_description && !homeData?.plan} />
    </div>
    );
};

export { AB_Home };
